import {
  CHANGE_SEARCH_FIELD,
  SearchActionTypes,
  ISearchState,
  SET_ROBOT_SET_FIELD,
  IRobotSetFieldAction,
} from "./types";

const initialState: ISearchState = {
  searchField: "",
  set: "set1",
};

const searchReducer = (
  state: ISearchState = initialState,
  action: SearchActionTypes
): ISearchState => {
  switch (action.type) {
    case CHANGE_SEARCH_FIELD:
      return { ...state, searchField: action.payload };
    case SET_ROBOT_SET_FIELD:
      return { ...state, set: (action as IRobotSetFieldAction).payload };
    default:
      return state;
  }
};

export default searchReducer;
